const paths = {
  ARRIVAL_PATH: "/arrival",
  COMPLETE_PATH: "/complete",
  DEPARTURE_PATH: "/departure",
  EDUCATION_PATH: "/education",
  PERSONALITY_PROFILE_PATH: "/personality_profile",
  GUARDIAN_EMERGENCY_PATH: "/guardian_emergency",
  LANGUAGE_NATIONALITY_PATH: "/language_nationality",
  MEDICAL_PATH: "/medical",
  PETS_CHILDREN_PATH: "/pets_children",
  PLACEMENT_PATH: "/placement",
  PRODUCT_PATH: "/product",
  REGISTER_PATH: "/register",
  FIREBASE_REGISTER_PATH: "/firebase_register_form",
  FIREBASE_ACCOUNT_DETAILS_PATH: "/firebase_account_details_form",
  RETURN_LATER_PATH: "/return_later",
  ADDRESS_PATH: "/"
}

export default paths
